__turbopack_context__.v({
  "signupAfro": "signup-modal-module-sass-module__CySR0q__signupAfro",
  "signupCompact": "signup-modal-module-sass-module__CySR0q__signupCompact",
  "signupCpf": "signup-modal-module-sass-module__CySR0q__signupCpf",
  "signupDefault": "signup-modal-module-sass-module__CySR0q__signupDefault",
});
